import { BaseService } from '@utex/base-api-sdk';
export class MobileApplicationVersionService extends BaseService {
    constructor() {
        super(...arguments);
        this.clientName = 'MobileApplicationVersionService';
        this.checkVersion = this.createRest('/rest/grpc/com.dizraptor.dizraptor.gateway.MobileApplicationVersionService.checkVersion', false, 'schema.json#/properties/checkVersionRequest', 'schema.json#/properties/checkVersionResponse', 'MobileApplicationVersionService/checkVersion');
    }
}
//# sourceMappingURL=MobileApplicationVersionService.js.map